import "@shoelace-style/shoelace/dist/components/icon/icon.js";
import React from "react";

/**
 * ContentBlockEditor - Component for editing dynamic content blocks
 *
 * @param {Object} props
 * @param {Array} props.blocks - Array of content blocks
 * @param {Function} props.onAddBlock - Handler for adding a block
 * @param {Function} props.onRemoveBlock - Handler for removing a block
 * @param {Function} props.onBlockChange - Handler for changing block content
 * @param {Function} props.onTypeChange - Handler for changing block type
 */
const ContentBlockEditor = ({
  blocks,
  onAddBlock,
  onRemoveBlock,
  onBlockChange,
  onTypeChange,
}) => {
  const renderBlockContent = (block) => {
    switch (block.type) {
      case "heading":
        return (
          <input
            type="text"
            value={block.content}
            onChange={(e) => onBlockChange(block.id, e.target.value)}
            className="w-full p-2 border border-[#2f3236] rounded text-xl font-bold focus:ring-[#4db1e0] focus:border-[#4db1e0] bg-[#262b30] text-gray-200"
            placeholder="Heading"
          />
        );
      case "list":
        return (
          <textarea
            value={block.content}
            onChange={(e) => onBlockChange(block.id, e.target.value)}
            className="w-full p-2 border border-[#2f3236] rounded focus:ring-[#4db1e0] focus:border-[#4db1e0] bg-[#262b30] text-gray-200"
            placeholder="List items (one per line)"
            rows={4}
          />
        );
      default:
        return (
          <textarea
            value={block.content}
            onChange={(e) => onBlockChange(block.id, e.target.value)}
            className="w-full p-2 border border-[#2f3236] rounded focus:ring-[#4db1e0] focus:border-[#4db1e0] bg-[#262b30] text-gray-200"
            placeholder="Text content"
            rows={3}
          />
        );
    }
  };

  return (
    <div className="space-y-4">
      <div className="flex justify-between items-center">
        <label className="block text-sm font-medium text-gray-300">
          Content Blocks
        </label>
        <div className="flex space-x-2">
          <button
            type="button"
            onClick={() => onAddBlock("text")}
            className="px-2 py-1 text-xs bg-[#262b30] text-gray-300 rounded hover:bg-[#2f3236] border border-[#2f3236]"
          >
            + Text
          </button>
          <button
            type="button"
            onClick={() => onAddBlock("heading")}
            className="px-2 py-1 text-xs bg-[#262b30] text-gray-300 rounded hover:bg-[#2f3236] border border-[#2f3236]"
          >
            + Heading
          </button>
          <button
            type="button"
            onClick={() => onAddBlock("list")}
            className="px-2 py-1 text-xs bg-[#262b30] text-gray-300 rounded hover:bg-[#2f3236] border border-[#2f3236]"
          >
            + List
          </button>
        </div>
      </div>

      {blocks.map((block) => (
        <div
          key={block.id}
          className="relative border border-[#2f3236] rounded p-4 bg-[#262b30]"
        >
          <div className="flex justify-between items-center mb-2">
            <select
              value={block.type}
              onChange={(e) => onTypeChange(block.id, e.target.value)}
              className="text-sm border-[#2f3236] bg-[#1a1e21] text-gray-300 rounded"
            >
              <option value="text">Text</option>
              <option value="heading">Heading</option>
              <option value="list">List</option>
            </select>

            {blocks.length > 1 && (
              <button
                type="button"
                onClick={() => onRemoveBlock(block.id)}
                className="text-sm text-gray-400 hover:text-red-400"
              >
                <sl-icon name="trash"></sl-icon>
              </button>
            )}
          </div>
          {renderBlockContent(block)}
        </div>
      ))}
    </div>
  );
};

export default ContentBlockEditor;
